import React from 'react';

export default function HeadlineCopy() {
  return (
    <div 
      className="font-inter font-bold text-[40px] leading-[100%] text-center mx-auto flex items-center justify-center" 
      data-node-id="2378:2709"
      style={{ 
        background: 'linear-gradient(135deg, #253658 0%, #4481fd 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text'
      }}
    >
      <p className="leading-[normal]">
        <span className="block inline">What avatar do you</span>
        <span className="block inline"> want to create?</span>
      </p>
    </div>
  );
}
